{
  "commonHeader": {
    "toggleSidebar": "Показать или скрыть боковую панель",
    "cartLoading": "Загрузка корзины",
    "cart": "Корзина",
    "aicForAdmin": {
      "ariaLabel": "ИИ для администраторов"
    },
    "usersResults": "Пользователи, результатов: {0}",
    "settingsResults": "Настройки, результатов: {0}",
    "navigationResults": "Навигация, результатов: {0}",
    "learnMoreAbout": "Подробнее о {0}",
    "close": "Закрыть",
    "products": "Продукты",
    "moreActions": "Другие действия",
    "search": "Поиск",
    "searchPlaceholderAll": "Поиск пользователей, настроек учетной записи или навигации",
    "searchPlaceholderUsers": "Поиск пользователей или навигации",
    "searchPlaceholderSettings": "Поиск настроек учетной записи или навигации",
    "searchPlaceholderNav": "Поиск в навигации"
  },
  "footerCopyright": {
    "language": "Язык {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Меню администратора"
    }
  },
  "shared": {
    "close": "Закрыть",
    "sideMenu": {
      "personalAria": "Личное меню",
      "adminAria": "Меню администратора",
      "mainNav": "Основная навигация",
      "submenu": "Подменю",
      "pinnedSection": "{0} закреплено",
      "sideMenuAria": "Боковое меню",
      "pinItem": "Закрепить {0}",
      "unpinItem": "Открепить {0}",
      "reorderGrabbed": "Изменение порядка {0}, элемент захвачен. Используйте стрелки вверх и вниз для перемещения, пробел или Enter для размещения, Escape для отмены.",
      "reorderIdle": "Изменить порядок {0}. Нажмите пробел или Enter, чтобы захватить.",
      "hintHandlePin": "Нажмите Tab, чтобы перейти к маркеру перетаскивания и кнопке закрепления",
      "hintHandle": "Нажмите Tab, чтобы перейти к маркеру перетаскивания",
      "hintPin": "Нажмите Tab, чтобы перейти к кнопке закрепления",
      "upgradeToPro": "Перейти на Pro"
    },
    "item": "Элемент"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Попробовать новый интерфейс"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Закрыть"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Подразделения теперь доступны"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Управление внешними учетными записями"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Адресная книга станет Каталогом клиентов"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Категория продукта",
    "itemLableForFeedback": "Обратная связь"
  }
}
